export type UpdateFn = (dt: number) => void;
export type RenderFn = (interpolation: number) => void;

export class GameLoop {
  private running = false;
  private rafId = 0;
  private lastTime = 0;
  private accumulator = 0;
  private readonly stepSeconds: number;
  private readonly maxFrameDelta: number;

  constructor(
    private readonly onUpdate: UpdateFn,
    private readonly onRender: RenderFn,
    stepHz: number,
    maxFrameDelta: number
  ) {
    this.stepSeconds = 1 / stepHz;
    this.maxFrameDelta = maxFrameDelta;
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    this.lastTime = performance.now();
    this.accumulator = 0;
    this.rafId = requestAnimationFrame(this.tick);
  }

  stop(): void {
    if (!this.running) return;
    this.running = false;
    cancelAnimationFrame(this.rafId);
  }

  isRunning(): boolean {
    return this.running;
  }

  private tick = (now: number): void => {
    if (!this.running) return;

    let frameDelta = (now - this.lastTime) / 1000;
    if (frameDelta > this.maxFrameDelta) frameDelta = this.maxFrameDelta;
    this.lastTime = now;
    this.accumulator += frameDelta;

    while (this.accumulator >= this.stepSeconds) {
      this.onUpdate(this.stepSeconds);
      this.accumulator -= this.stepSeconds;
    }

    const interpolation = this.accumulator / this.stepSeconds;
    this.onRender(interpolation);

    this.rafId = requestAnimationFrame(this.tick);
  };
}
